import { calcTaxAmt } from "../../../objects/AssetsExpenses/taxAmtCalc_function";

export const calculateSavingsTax = (interestEarned, assetTable, gameDate, taxRate, taxTranNbr) => {
        taxTranNbr += 1;
        let regularTaxRate = taxRate;
        if (taxRate === 0){
            regularTaxRate = +calcTaxAmt(assetTable, "regular", "TaxRate");
        }
        const regularTaxAmt = 
                    (interestEarned * regularTaxRate * -1).toFixed(2);
        const taxTransaction = {tranType: "regularTax", tranAmount: regularTaxAmt, tranNbr: taxTranNbr.toString(),
            taxRate: regularTaxRate.toString(), incomeAmt: interestEarned.toString(), tranDate: gameDate,
            taxLongText: "Federal Income Tax"};
        const returnObj={taxAmt: regularTaxAmt, taxTran: taxTransaction, taxRate: regularTaxRate,
            tranNbr: taxTranNbr
        }
        return returnObj;
}
export default calculateSavingsTax;